import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../styles/WelcomePopup.css';

const WelcomePopup = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentPath, setCurrentPath] = useState('');
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    // Replace this with your actual image URL or import
    const ownerImageUrl = '/Assets/image/Sajid-ali.jpeg'; // Update this path to your image

    // Prevent background scrolling when popup is open
    useEffect(() => {
        if (isOpen) {
            // Save current scroll position
            const scrollY = window.scrollY;

            // Disable scrolling and fix the body in place
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling and restore position
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }

        return () => {
            // Cleanup function to ensure scrolling is restored
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        };
    }, [isOpen]);

    useEffect(() => {
        // Get current path
        setCurrentPath(window.location.pathname);

        // Only show popup on homepage
        if (window.location.pathname === '/') {
            // Show popup after a short delay when component mounts
            const timer = setTimeout(() => {
                setIsOpen(true);
            }, 1500);

            return () => clearTimeout(timer);
        }
    }, []);

    const closePopup = () => {
        setIsOpen(false);
        // Store in session storage to prevent showing again in the same session
        sessionStorage.setItem('welcomePopupShown', 'true');
    };

    // Check if popup has already been shown in this session
    useEffect(() => {
        const hasBeenShown = sessionStorage.getItem('welcomePopupShown');
        if (hasBeenShown === 'true') {
            setIsOpen(false);
        }
    }, []);

    const handleImageLoad = () => {
        setImageLoaded(true);
        setImageError(false);
    };

    const handleImageError = () => {
        setImageError(true);
        setImageLoaded(false);
    };

    const popupVariants = {
        hidden: {
            opacity: 0,
            scale: 0.9
        },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 30,
                duration: 0.4
            }
        },
        exit: {
            opacity: 0,
            scale: 0.9,
            transition: { duration: 0.3 }
        }
    };

    // Only render on homepage
    if (currentPath !== '/' && currentPath !== '') {
        return null;
    }

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="popup-overlay">
                    <motion.div
                        className="welcome-popup"
                        variants={popupVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <button className="close-popup" onClick={closePopup}>×</button>

                        <div className="popup-header">
                            <h2>Welcome to Excellent Travels</h2>
                            <div className="visa-specialist-badge">
                                <span className="badge-icon">✓</span>
                                <span className="badge-text">Visa Specialists</span>
                            </div>
                        </div>

                        <div className="popup-content">
                            <div className="popup-left">
                                <div className="owner-placeholder">
                                    {!imageError && (
                                        <img
                                            src={ownerImageUrl}
                                            alt="M Sajid Ali - Founder & CEO"
                                            className={`owner-image ${imageLoaded ? 'loaded' : ''}`}
                                            onLoad={handleImageLoad}
                                            onError={handleImageError}
                                        />
                                    )}
                                    {(!imageLoaded || imageError) && (
                                        <span className={`owner-initials ${imageLoaded ? 'hide' : ''}`}>SA</span>
                                    )}
                                </div>
                                <div className="owner-caption">
                                    <h3>M Sajid Ali</h3>
                                    <p>Founder & CEO</p>
                                    <p>25+ Years Experience</p>
                                </div>
                            </div>

                            <div className="popup-right">
                                <div className="benefits-list">
                                    <div className="benefit-item">
                                        <div className="benefit-icon">🌟</div>
                                        <div className="benefit-text">
                                            <h4>Visa Consultation</h4>
                                            <p>Expert guidance for all visa types</p>
                                        </div>
                                    </div>

                                    <div className="benefit-item">
                                        <div className="benefit-icon">⚡</div>
                                        <div className="benefit-text">
                                            <h4>Fast Processing</h4>
                                            <p>Quick turnaround on applications</p>
                                        </div>
                                    </div>

                                    <div className="benefit-item">
                                        <div className="benefit-icon">🔒</div>
                                        <div className="benefit-text">
                                            <h4>High Success Rate</h4>
                                            <p>Proven track record of approvals</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="popup-footer">
                            <Link to="/contact" className="contact-button" onClick={closePopup}>
                                Contact Us Now
                            </Link>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default WelcomePopup;